import { render, staticRenderFns } from "./MerchantRateCard.vue?vue&type=template&id=a48e13d4&scoped=true&"
import script from "./MerchantRateCard.vue?vue&type=script&lang=js&"
export * from "./MerchantRateCard.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRateCard.vue?vue&type=style&index=0&id=a48e13d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48e13d4",
  null
  
)

export default component.exports